import React, { useCallback } from 'react';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import style from './ButtonBlock.module.scss';

interface IButtonBlock {
	setActiveColors: (val: 'general' | 'additional') => void;
	activeColors: 'general' | 'additional';
}

const ButtonBlock: React.FC<IButtonBlock> = ({ setActiveColors, activeColors }) => {
	const setGeneralColor = useCallback(() => setActiveColors('general'), []);
	const setAdditionalColor = useCallback(() => setActiveColors('additional'), []);

	return (
		<div className={style.container}>
			<Button onClick={setGeneralColor} theme={activeColors === 'general' ? 'primaryBlue' : 'secondary'}>
				<Text translationNameSpace="mediaSettings" translationKey="generalColors" asFragment={true} />
			</Button>
			<Button onClick={setAdditionalColor} theme={activeColors === 'additional' ? 'primaryBlue' : 'secondary'}>
				<Text translationNameSpace="mediaSettings" translationKey="additionalColors" asFragment={true} />
			</Button>
		</div>
	);
};

export default React.memo(ButtonBlock);
